var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},[_c('alert-detail',{attrs:{"id":_vm.id},on:{"close":function($event){return _vm.$router.push({ name: 'alerts' })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }